import type { HTMLAttributes } from 'react';
import styles from './Pill.module.css';

export type IPillProps = HTMLAttributes<HTMLSpanElement>;

/**
 * A status chip: the shape only. The caller colours it with a tone class
 * (`className`) from its own status → tone mapping — documents, tasks and
 * issues each speak their own status vocabulary, but read as one chip.
 */
export function Pill({ className, ...rest }: IPillProps) {
  return <span className={[styles.pill, className].filter(Boolean).join(' ')} {...rest} />;
}
